import { Box, IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import profilePicture from "../../assets/img/profile-picture.jpg";
import React, { useState, useEffect } from "react";
import { Popover, List, Avatar, message } from "antd";
import Cookies from "js-cookie";
import { UserOutlined, UploadOutlined } from "@ant-design/icons";
import SettingsIcon from "@mui/icons-material/Settings";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";

const PopoverContent = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/user/notification/viewNotification",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setNotifications(data["Notifications"]);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  return (
    <List
      style={{
        height: "350px",
        width: "250px",
        overflowY: "scroll",
        marginLeft: "10px",
      }}
      itemLayout="horizontal"
      dataSource={notifications}
      renderItem={(item) => (
        <div
          className="notification_item"
          onClick={() => console.log(item.id)}
          style={{ cursor: "pointer" }}
        >
          <a
            href="#"
            onClick={() => console.log(item.id)}
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              fontSize: "13px",
              color: "rgba(0,0,0,0.6)",
            }}
          >
            {item.subject}
          </a>
          <div
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              fontSize: "12px",
              color: "rgba(0,0,0,0.4)",
            }}
          >
            {item.message}
          </div>
        </div>

        // <List.Item>

        //   <List.Item.Meta
        //     title={
        //       <a href="#" onClick={() => console.log(item.id)}>
        //         {item.subject}
        //       </a>
        //     }
        //     description={item.message}
        //   />
        // </List.Item>
      )}
    />
  );
};

const Topbar = ({ userDetails }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [visible, setVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [data, setData] = useState([]);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  useEffect(() => {
    // Function to get the value of a URL parameter by name
    const getUrlParameter = (name) => {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      const results = regex.exec(window.location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    // Get the token parameter from the URL
    const tokenParam = getUrlParameter("token");

    // Check if a token is present in the URL
    if (tokenParam) {
      // Store the token in cookies
      console.log(tokenParam);
      Cookies.set("yourTokenCookieName", tokenParam, { expires: 720 }); // Set an expiration if needed
    }

    async function fetchData() {
      // const profilePictureUrl =
      //   (await loadprofilepicture()) || Cookies.get("profile_picture");
      // if (profilePictureUrl) {
      //   setImageUrl(profilePictureUrl);
      //   console.log(profilePictureUrl);
      // }
    }
    fetchData();
  }, []);
  const history = useHistory();
  const location = useLocation();

  const redirectToUrl = (path) => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    let redirectTo = path;

    if (code && state) {
      redirectTo += `?code=${code}&state=${state}`;
    }

    history.push(redirectTo);
  };

  const [initialName, setInitialName] = useState("SL");

  useEffect(() => {
    if (userDetails) {
      const textToSplit = userDetails.entity_name
        ? userDetails.entity_name.split(" ")
        : userDetails.principal_name
        ? userDetails.principal_name.split(" ")
        : null;
      if (textToSplit !== null) {
        console.log(textToSplit);
        const initials =
          textToSplit?.[0]?.[0]?.toUpperCase() +
          (textToSplit?.[1]?.[0]?.toUpperCase() || "");
        setInitialName(initials);
      }
    }
  }, [userDetails]);

  const loadprofilepicture = async () => {
    console.log("getting profile picture");
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/viewInfoProfilePicture",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (response.status === 401) {
        if (!Cookies.get("expressauth")) {
          Cookies.remove("token");
          // window.location.href = "/auth/signin";

          try {
            const response = await fetch(
              "https://www.smart-lend.com/api/user/logout",
              {
                method: "POST",
                redirect: "manual", // don't follow the redirect
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${Cookies.get("token")}`,
                },
              }
            );
            console.log("response status value", response.status);
            if (response.status === 200) {
              // Clear user session and navigate to login page
              Cookies.remove("token");
              window.location.href = "/auth/signin";
            } else if (response.status === 0) {
              window.location.href = "/auth/signin";
            }
            // if (!response.ok) {
            //   throw new Error("Logout failed");
            // }
          } catch (error) {
            console.error(error);
            // Display error message to user
            alert("Login failed. Please try again.");
          }
        } else {
          redirectToUrl("/director-authorization");
        }
      } else if (!response.ok) {
        throw new Error("Failed to fetch profile picture");
      }

      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      console.log("Profile picture retrieved", imageUrl);
      return imageUrl;
    } catch (error) {
      console.error("Error retrieving profile picture", error);
      return null;
    }
  };

  const [screenWidth, setScreenWidth] = useState("1920");

  const [changeProfileIsOpen, setChangeProfileIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [accounts, setAccounts] = useState([]);
  const [myuserId, setMyUserId] = useState("");

  const getLinkedAccounts = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/checkOtherLinkAccounts",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.ok) {
        const json = await response.json();
        setAccounts(json.accounts);
        setMyUserId(json.user_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getLinkedAccounts();
  }, []);

  const createBorrowerLinkedAccount = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/createLinkedBorrowerAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      if (response.ok) {
        const json = await response.json();
        message.success("Linked account created!");
        setAccounts([...accounts, json.newUser]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const vpnToAccount = async (user_id) => {
    try {
      const formData = new FormData();
      formData.append("userId", user_id);

      const response = await fetch(
        "https://www.smart-lend.com/api/admin/vpnToUserAccount",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        Cookies.set("vpnToAccount", "true");
        Cookies.set("token", json.token);
        Cookies.set("user_account_type", "borrower");
        window.location.href = "https://smart-lend.com/b-dashboard";
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {changeProfileIsOpen ? (
        <div
          style={{
            position: "fixed",
            height: "100vh",
            width: "100vw",
            overflow: "hidden",
            background: "var(--br-surface, rgba(255,255,255,0.55))",
            backdropFilter: "blur(10px)",
            zIndex: 1000,
            top: 0,
            left: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 28,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: 32,
                flexWrap: "wrap",
                maxWidth: 900,
              }}
            >
              {accounts.map((acc, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      background:
                        myuserId === acc.user_id
                          ? "linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)"
                          : "rgba(140, 140, 170, 0.70)",
                      height: 112,
                      width: 112,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 900,
                      fontSize: 34,
                      color: "white",
                      border: "1px solid rgba(148,163,184,0.22)",
                      boxShadow: "var(--br-shadow, 0 18px 46px rgba(2,8,23,0.14))",
                      fontFamily: "Manrope, sans-serif",
                      userSelect: "none",
                    }}
                    onClick={() => vpnToAccount(acc.user_id)}
                  >
                    {acc.entity_name
                      ? (acc.entity_name.split(" ")?.[0]?.[0] || "S") +
                        (acc.entity_name.split(" ")?.[1]?.[0] || "L")
                      : acc.principal_name
                      ? (acc.principal_name.split(" ")?.[0]?.[0] || "S") +
                        (acc.principal_name.split(" ")?.[1]?.[0] || "L")
                      : "SL"}
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      color: "rgba(15,23,42,0.60)",
                      fontSize: 13,
                      lineHeight: "16px",
                      fontWeight: 700,
                      width: 160,
                      fontFamily: "Manrope, sans-serif",
                    }}
                  >
                    {acc.entity_name
                      ? acc.entity_name
                      : acc.principal_name
                      ? acc.principal_name
                      : "New profile"}
                  </div>
                </div>
              ))}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  cursor: "pointer",
                }}
                onClick={createBorrowerLinkedAccount}
              >
                <div
                  style={{
                    background: "rgba(140, 140, 170, 0.28)",
                    height: 112,
                    width: 112,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid rgba(148,163,184,0.22)",
                    boxShadow: "var(--br-shadow, 0 18px 46px rgba(2,8,23,0.10))",
                  }}
                >
                  <AddIcon style={{ color: "white", fontSize: 54 }} />
                </div>
              </div>
            </div>

            <CancelIcon
              style={{
                cursor: "pointer",
                color: "rgba(15,23,42,0.35)",
                fontSize: 46,
              }}
              onClick={() => setChangeProfileIsOpen(false)}
            />
          </div>
        </div>
      ) : null}

      {screenWidth > 1200 ? (
        <Box
          className="sl-borrower-topbar"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{
            padding: "14px 18px 10px 18px",
            gap: 14,
          }}
        >
          {/* SEARCH */}
          <div className="sl-borrower-topbar-search"
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "10px 12px",
              borderRadius: "var(--br-card-radius, 18px)",
              background: "var(--br-surface, rgba(255,255,255,0.72))",
              border: "1px solid rgba(148,163,184,0.22)",
              boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.08))",
              backdropFilter: "blur(10px)",
            }}
          >
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: "var(--br-card-radius, 12px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(241,245,249,0.85)",
                border: "1px solid rgba(148,163,184,0.18)",
              }}
            >
              <SearchIcon
                style={{ color: "rgba(15,23,42,0.55)", fontSize: 20 }}
              />
            </div>

            <InputBase
              className="input_base"
              placeholder="Search In Page"
              sx={{
                flex: 1,
                color: "rgba(15,23,42,0.85)",
                fontFamily: "Manrope, sans-serif",
                fontWeight: 800,
                fontSize: "13px",
                "& input::placeholder": {
                  opacity: 1,
                  color: "rgba(15,23,42,0.45)",
                  fontWeight: 800,
                },
              }}
            />
          </div>

          {/* RIGHT ACTIONS */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {/* Settings chip */}
            <div
              className="mui_button"
              style={{
                width: 40,
                height: 40,
                borderRadius: "var(--br-card-radius, 14px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--br-surface, rgba(255,255,255,0.72))",
                border: "1px solid rgba(148,163,184,0.22)",
                boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
                cursor: "pointer",
              }}
              onClick={() => {
                window.location.href = "/stg-b-profile";
              }}
            >
              <SettingsIcon
                style={{ color: "rgba(15,23,42,0.55)", fontSize: 20 }}
              />
            </div>

            {/* Avatar chip */}
            <div
              className="mui_button"
              style={{
                width: 40,
                height: 40,
                borderRadius: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                background:
                  "linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)",
                color: "white",
                fontFamily: "Manrope, sans-serif",
                fontWeight: 900,
                fontSize: 12,
                border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.18)",
                boxShadow: "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
                userSelect: "none",
              }}
              onClick={() => setChangeProfileIsOpen(true)}
              title="Switch profile"
            >
              {initialName}
            </div>
          </div>
        </Box>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{
            padding: "12px 14px 10px 14px",
            gap: 10,
          }}
        >
          {/* MOBILE SEARCH */}
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "9px 10px",
              borderRadius: "var(--br-card-radius, 16px)",
              background: "var(--br-surface, rgba(255,255,255,0.72))",
              border: "1px solid rgba(148,163,184,0.22)",
              boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
              marginLeft: "50px",
            }}
          >
            <SearchIcon
              style={{ color: "rgba(15,23,42,0.55)", fontSize: 18 }}
            />
            <InputBase
              placeholder="Search"
              sx={{
                flex: 1,
                color: "rgba(15,23,42,0.85)",
                fontFamily: "Manrope, sans-serif",
                fontWeight: 800,
                fontSize: "12px",
                "& input::placeholder": {
                  opacity: 1,
                  color: "rgba(15,23,42,0.45)",
                  fontWeight: 800,
                },
              }}
            />
          </div>

          {/* MOBILE AVATAR */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              background:
                "linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)",
              color: "white",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 900,
              fontSize: 12,
              border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.18)",
              boxShadow: "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
              userSelect: "none",
            }}
            onClick={() => setChangeProfileIsOpen(true)}
          >
            {initialName}
          </div>
        </Box>
      )}
    </>
  );
};

export default Topbar;
